<template>
<div class="main mt15">
	<div class="banner" @click="toBuy" ref="info">
		<img src="/static/images/haierProduct/guoshou_detail.jpg" alt="">
		<!-- <div class="banner-container">
			<div class="banner-container-title">企业团体雇主责任保险</div>
			<div class="banner-container-case">—  老板事业的护身符  —</div>
			<div class="banner-container-sub">
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>雇主意外</span>
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>职业病</span>
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>误工津贴</span>
			</div>
			<div class="banner-container-btn">
				<a class="btn" @click="toBuy">立即购买</a>
			</div>
		</div> -->
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="产品特色" name="info"></TabPane>
				<TabPane label="保障方案" name="case"></TabPane>
				<TabPane label="常见问题" name="question"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane>
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Button type="primary" @click="toBuy">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">产品特色</div>
		<div class="detail-main">
			<div class="detail-main-title">1、保额灵活、保障全面</div>
			<div class="detail-main-text">
				①、多阶梯保额可选，最高保额120万<br>
				②、多种附加险可选，24小时意外、自费药、提高伤残赔付比例都包含<br>
				③、不同工种可以选择不同的保障方案
			</div>
			<div class="detail-main-title">2、门槛低、覆盖范围广</div>
			<div class="detail-main-text">
				①、16-65周岁雇员均可投保<br>
				<span style="color:red">②、除拒保行业外，1-5类均可投保</span><br>
				③、1-12个月保期随意选择、支持月单
			</div>
			<div class="detail-main-title">3、出单简便，服务及时</div>
			<div class="detail-main-text" ref="case">
				①、全流程线上投保，订单提交后T+1日内收到保单<br>
				②、月单支持批增，年单支持批增、替换，100%替换率<br>
				③、订单提交后T+1日内，电子保单、批单发送到预留邮箱
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">保障方案</div>
		<div class="detail-main">
			<div class="center">
				<table class="productDetail-table">
					<thead>
						<tr>
							<th colspan="2" rowspan="2">方案</th>
							<th rowspan="2">死亡伤残</th>
							<th rowspan="2">医疗<br>(社保范围内用药)</th>
							<th rowspan="2">误工补贴</th>
							<th colspan="5">
								人员风险分类<a style="color:red;margin-left:20px;font-size:14px;" target="_blank" href="/static/pdf/haierProduct/guoshou/5-职业分类表.pdf">查看职业分类</a>
								<!-- <p><a href="/static/pdf/haierProduct/guoshou/5-职业分类表.pdf" target="_blank">雇主责任保险（A）条款</a></p> -->
							</th>
							<!-- <th rowspan="2">备注</th> -->
						</tr>
						<tr>
							<th>1-2类</th>
							<th>3类</th>
							<th>4类</th>
							<th>5类</th>
							<th>高空及6类</th>
						</tr>
					</thead>
					<tbody>
						<tr class="hoverTr">
							<td rowspan="8" width="100" class="hoverDisabled">基础方案</td>
							<td>方案一</td>
							<td>10万</td>
							<td>1万</td>
							<td>100元/天</td>
							<td>70</td>
							<td>130</td>
							<td>150</td>
							<td>300</td>
							<td>400</td>
						</tr>
						<tr class="hoverTr">
							<td>方案二</td>
							<td>20万</td>
							<td>2万</td>
							<td>100元/天</td>
							<td>122</td>
							<td>200</td>
							<td>250</td>
							<td>500</td>
							<td>780</td>
						</tr>
						<tr class="hoverTr">
							<td>方案三</td>
							<td>30万</td>
							<td>3万</td>
							<td>100元/天</td>
							<td>162</td>
							<td>300</td>
							<td>360</td>
							<td>750</td>
							<td>1150</td>
						</tr>
						<tr class="hoverTr">
							<td>方案四</td>
							<td>40万</td>
							<td>4万</td>
							<td>100元/天</td>
							<td>221</td>
							<td>400</td>
							<td>460</td>
							<td>900</td>
							<td>1500</td>
						</tr>
						<tr class="hoverTr">
							<td>方案五</td>
							<td>50万</td>
							<td>5万</td>
							<td>100元/天</td>
							<td>270</td>
							<td>480</td>
							<td>550</td>
							<td>1100</td>
							<td>1900</td>
						</tr>
						<tr class="hoverTr">
							<td>方案六</td>
							<td>80万</td>
							<td>10万</td>
							<td>100元/天</td>
							<td>380</td>
							<td>780</td>
							<td>880</td>
							<td>1550</td>
							<td>2600</td>
						</tr>
						<tr class="hoverTr">
							<td>方案七</td>
							<td>100万</td>
							<td>12万</td>
							<td>100元/天</td>
							<td>500</td>
							<td>1100</td>
							<td>1300</td>
							<td>2000</td>
							<td>3700</td>
						</tr>
						<tr class="hoverTr">
							<td>方案八</td>
							<td>120万</td>
							<td>15万</td>
							<td>100元/天</td>
							<td>800</td>
							<td>1300</td>
							<td>1600</td>
							<td>3000</td>
							<td>4500</td>
						</tr>
						<tr>
							<td rowspan="3">附加方案</td>
							<td>附加24小时意外</td>
							<td colspan="8" style="text-align: left;">
								承保时间范围扩展至全天24小时，被保险人之雇员因意外事故而导致的死亡、伤残、医疗赔偿金，按照人身意外伤害条款约定赔付。
								<b>基础方案价格*115%</b>
							</td>
						</tr>
						<tr>
							<td>附加自费药</td>
							<td colspan="8" style="text-align: left;">
								不再按照被保险人当地医保标准赔偿承保所有治疗费用中社保范围外合理的自费药部分费用
								<b>基础方案价格*120%</b>
							</td>
						</tr>
						<tr>
							<td>附加伤残赔偿比例调整</td>
							<td colspan="8" style="text-align: left;">
								将伤残等级对应的赔偿比例进行调高（具体调整比例见
								<a @click="toSC('SC')">伤残赔偿比例表</a>）
								<b>基础方案价格*115%</b>
							</td>
						</tr>
					</tbody>
				</table>
				<table class="productDetail-table mt20">
					<tbody>
						<tr>
							<td class="firstRow" width="200">适用人群</td>
							<td style="text-align: left;">
								雇员年龄<b class="importantText">16-65周岁</b>，最低起保人数<b class="importantText">5人</b>
							</td>
						</tr>
						<tr>
							<td class="firstRow">死亡赔偿</td>
							<td style="text-align: left;">
								按保险单约定的每人死亡伤残赔偿限额计算死亡赔偿金额。
							</td>
						</tr>
						<tr>
							<td class="firstRow">伤残赔偿</td>
							<td style="text-align: left;">
								依据伤残鉴定机构出具的伤残程度鉴定书，按每人死亡伤残赔偿限额及 “<a @click="toSC('SC')">伤残等级赔偿限额比例表</a>”规定的比例计算伤残赔偿金额。
							</td>
						</tr>
						<tr>
							<td class="firstRow">医疗费用</td>
							<td style="text-align: left;">
								赔偿社保范围内的医疗费用，具体包括：<br>
								1．挂号费、治疗费、手术费、检查费、医药费、材料费、急救车费；<br>
								2．住院期间的床位费、取暖费、空调费。
							</td>
						</tr>
						<tr>
							<td class="firstRow">误工费用</td>
							<td style="text-align: left;">
								被保险人雇员暂时丧失工作能力持续五天以上的，经医院开具误工证明，每次事故每人赔付不超过90 天，全年累计每人最高不超过180 天。
							</td>
						</tr>
						<tr>
							<td class="firstRow">禁保行业</td>
							<td style="text-align: left;">
								道路清洁、渔业生产、远洋运输、采矿业、木材加工、石材加工、修造船业、空调/电梯安装维修；水下作业、地下作业、海上作业（渔业、油矿开采等）、矿业/采石业、森林防火员、体育运动、影视及演艺业、战地记者、驯兽师、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除、高炉相关工作、金属冶炼、钢缆生产加工、船舶/化工/军工相关工作、涉及烟花爆竹/火药/炸药/爆破的相关工作、保镖、特种兵/军人/武警/公安/警察/消防等治安人员、大型管道（水下或地下）/公路/山路/铁路/桥梁/水利/隧道工程。<br>
另：投保公司名头中带有“人力资源”、“劳务/派遣公司”、“企业管理公司”的业务不予承保。
							</td>
						</tr>
						<tr>
							<td class="firstRow">保单时效</td>
							<td style="text-align: left;">
								年保单可批增、替换、不允许减人；短期保单可新增、不允许替换、减人。保期不足一年保费按照<a @click="toSC('DQ')">短期费率</a>进行收取。
							</td>
						</tr>
						<tr>
							<td class="firstRow">注意事项</td>
							<td style="text-align: left;">
								非高空作业：保单不承担被保险人从事高处作业时所发生保险事故的赔偿责任。高处作业指凡在坠落高度基准面2M 以上（含2M）有可能坠落的高处进行的作业；<br>
高空作业：被保险人从事高空作业时，必须按照相关行业安全管理规定（包括但不限于必须佩带安全绳、安全带或者安装防护网架等安全设施设备）开展作业活动，否则保险公司对可能发生的人身伤亡及医疗费用不承担赔偿责任。
							</td>
						</tr>
					</tbody>
				</table>
				<div class="detail-main-text align-left pt40" ref="SC"><b>伤残比例赔付表</b></div>
				<div class="center">
					<table class="productDetail-table">
						<thead>
							<tr>
								<th width="200">伤残等级</th>
								<th>一级</th>
								<th>二级</th>
								<th>三级</th>
								<th>四级</th>
								<th>五级</th>
								<th>六级</th>
								<th>七级</th>
								<th>八级</th>
								<th>九级</th>
								<th>十级</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="firstRow">初始赔偿比例</td>
								<td class="pd0">100%</td>
								<td class="pd0">80%</td>
								<td class="pd0">70%</td>
								<td class="pd0">60%</td>
								<td class="pd0">50%</td>
								<td class="pd0">40%</td>
								<td class="pd0">30%</td>
								<td class="pd0">20%</td>
								<td class="pd0">10%</td>
								<td class="pd0">5%</td>
							</tr>
							<tr>
								<td class="firstRow">附加伤残赔偿比例</td>
								<td class="pd0">100%</td>
								<td class="pd0">90%</td>
								<td class="pd0">80%</td>
								<td class="pd0">70%</td>
								<td class="pd0">60%</td>
								<td class="pd0">50%</td>
								<td class="pd0">40%</td>
								<td class="pd0">30%</td>
								<td class="pd0">20%</td>
								<td class="pd0">10%</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="detail-main-text align-left pt40" ref="DQ"><b>短期费率表</b></div>
				<div class="center">
					<table class="productDetail-table">
						<thead>
							<tr>
								<th width="200">保险期间经过月数</th>
								<th>1个月</th>
								<th>2个月</th>
								<th>3个月</th>
								<th>4个月</th>
								<th>5个月</th>
								<th>6个月</th>
								<th>7个月</th>
								<th>8个月</th>
								<th>9个月</th>
								<th>10个月</th>
								<th>11个月</th>
								<th>12个月</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="firstRow">年费率的比例</td>
								<td class="pd0">10%</td>
								<td class="pd0">20%</td>
								<td class="pd0">30%</td>
								<td class="pd0">40%</td>
								<td class="pd0">50%</td>
								<td class="pd0">60%</td>
								<td class="pd0">70%</td>
								<td class="pd0">80%</td>
								<td class="pd0">85%</td>
								<td class="pd0">90%</td>
								<td class="pd0">95%</td>
								<td class="pd0">100%</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="detail-main-text align-left pt40"><b>产品条款查看：</b></div>
				<div style="font-size: 14px;text-align: left;padding-left: 20px;"  ref="question">
					<p><a href="/static/pdf/haierProduct/guoshou/雇主责任保险（A）条款.pdf" target="_blank">雇主责任保险（A）条款</a></p>
					<p><a href="/static/pdf/haierProduct/guoshou/雇主责任保险附加二十四小时人身意外扩展保险条款.pdf" target="_blank">雇主责任保险附加二十四小时人身意外扩展保险条款</a></p>
					<p><a href="/static/pdf/haierProduct/guoshou/雇主责任保险（A）附加自费药保险条款.pdf" target="_blank">雇主责任保险（A）附加自费药保险条款</a></p>
					<p><a href="/static/pdf/haierProduct/guoshou/雇主责任保险（A）附加伤残赔偿比例调整保险条款.pdf" target="_blank">雇主责任保险（A）附加伤残赔偿比例调整保险条款</a></p>
				</div>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">常见问题</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p><b>1.这个保险都能保什么？</b></p>
				<p>
					答：以工伤保险条例为标准，保障企业雇员在工作期间的意外事故，包含上下班途中、包含猝死责任。
				</p>
				<p><b>2.如何确定雇员的风险等级（职业类别）？</b></p>
				<p>答：投保流程中的选择工种处可以查询选择工种，选择对应的工种后系统自动匹配职业类别。</p>
				<p><b>3. 如何测算保费？</b></p>
				<p>答：进入填写投保信息界面，①选择保障时间②查询并选择工种③选择保障方案④选择投保人数，即可显示测算保费。</p>
				<p><b>4.同一公司不同工种能否选择不同方案？</b></p>
				<p>答：针对于不同工种可选择不同保障额度的方案，最大限度节约公司成本，同一法人企业累计最低投保人数为5人。</p>
				<p><b>5.这个保险医疗赔付比例是怎样的？</b></p>
				<p>答：基础方案社保范围内100%赔付，免赔100元。附加自费用药附加险全部费用100%赔付，免赔100元。</p>
				<p><b>6.理赔时对就医医院是否有什么要求？</b></p>
				<p>答：必须是二级以上医院（如果是紧急意外，可以到就近医院治疗，稳定后需要转移到二级以上医院）。</p>
				<p><b>6.投保后怎么拿到保单和发票？</b></p>
				<p>答：线上投保，付款提交后最晚次日电子保单发送到预留邮箱，电子发票发送到预留邮箱，专票寄到客户投保时留的邮寄地址。</p>
			</div>
		</div>
	</div>
	<div class="detail" ref="claim">
		<div class="detail-title">理赔流程</div>
		<Steps class="mt30">
			<Step 
				title="拨打报案电话" 
				status="process"
				content="请立即拨打报案电话95519进行报案，详细说明出险情况。"
			></Step>
			<Step 
				title="提交索赔材料" 
				status="process"
				content="书面告知您的索赔须知内容提交索赔所需的全部材料，我们将协助准备相应材料"
			></Step>
			<Step 
				title="领取赔款" 
				status="process"
				content="保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款"
			></Step>
		</Steps>
		<br>
		<br>
	</div>
	<TrackNotice />
</div>
</template>
<script>
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
	data () {
		return {
			rules:{
				code:[{required:true,message:'请输入88码',trigger:'blur'}]
			},
			tabName:'info',
			fixed:false,
			renewId:this.$route.query.renewId||'' //续保，上一保单id
		}
	},
	mounted() {
		//增加回溯逻辑
		this.track_is_new = true;
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll); 
			this.trackInit(); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods:{
		// 立即购买
		toBuy() {
			this.stopRecord({
				is_new: true
			}).then(()=>{
				let url='/haierProduct.html#/company-group-employergs/fillin';
				if(this.renewId)url+=`/${this.renewId}?renew=1&productCode=GSCGZZRXPCUPDA`
				else url+=`?productCode=GSCGZZRXPCUPDA`
				location.href=url
			})
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
			})
		},
		// 定位到伤残费率表位置
		toSC(key) {
			this.$refs[key].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
	  	  		block:    "center"  // 上边框与视窗顶部平齐。默认值
			})
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		margin-bottom: 30px;
	}
	.pb50{
		padding-bottom: 50px;
	}
	.pt40{
		padding-top: 40px;
	}
	.banner{
		cursor: pointer;
	}
	.banner-container{
		position: absolute;
		font-size: 14px;
		text-align:center;
		width: 510px;
		top:80px;
		left:0;
		right:0;
		color:#fff;
		.notes{
			margin-top: 10px;
		}
		&-title{
			font-size: 32px;
			color: #333;
		}
		&-case{
			font-size: 24px;
			line-height: 2;
			color: #318af0;
		}
		&-sub{
			font-size: 14px;
			color: #555;
			margin-top: 30px;
			span{
				margin-right: 5px;
			}
		}
		&-desc{
			font-size: 18px;
		}
		&-input{
			width:300px;
			margin:20px auto 0;
		}
		&-btn{
			margin-top: 30px;
			a{
				width:240px;
			}
		}
	}
	.detail-title{
		font-size: 30px;
	}
	.detail-main{
		.center{
			font-size: 0;
		}
		&-title,&-text{
			padding-left: 20px;
		}
		&-title{
			font-size: 18px;
		}
		&-text{
			line-height:2;
		}
	}
	.tabs{
		display: block;
		height: 46px;
		&-container{
			padding: 10px 10px 0;
			background: #fff;
			height: 46px;
			overflow: hidden;
			position: relative;
			&-form{
				position: absolute;
				right: 10px;
				bottom: 5px;
				button{
					display: inline-block;
				}
			}
		}
		.fixed{
			position: fixed;
			top: 100px;
			left: 0;
			right: 0;
			margin: auto;
			width: 1200px;
		}
	}

	.productDetail-table.sm{
		font-size: 13px;
		.fs16{
			font-size: 16px;
		}
		td{
			padding:8px;
		}
	}
	.hoverTr:hover{
		color: #fff;
		td{
			background: #77adf5;
		}
		.hoverDisabled{
			background: #fafafa;
			color: #333;
		}
	}
	.importantText{
		color: #77adf5;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerGS/Index.vue